import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import { DeleteOverlay, DeleteCard, DeleteConfirmText, DeleteConfirmActions, FooterButton } from '../common/styled';

export interface DeleteConfirmationOverlayProps {
    productName: string;
    onCancel: () => void;
    onConfirm: () => void;
}

export const DeleteConfirmationOverlay: FC<DeleteConfirmationOverlayProps> = ({ productName, onCancel, onConfirm }) => (
    <DeleteOverlay onClick={onCancel}>
        <DeleteCard onClick={(e) => e.stopPropagation()}>
            <DeleteConfirmText>
                {T._('This will permanently delete', 'Admin')} <strong>{productName}</strong>.
                <br />
                {T._('This action cannot be undone.', 'Admin')}
            </DeleteConfirmText>
            <DeleteConfirmActions>
                <FooterButton onClick={onCancel}>{T._('Cancel', 'Admin')}</FooterButton>
                <FooterButton
                    $danger
                    onClick={() => {
                        onCancel();
                        onConfirm();
                    }}
                >
                    {T._('Delete', 'Admin')}
                </FooterButton>
            </DeleteConfirmActions>
        </DeleteCard>
    </DeleteOverlay>
);
